import { render } from "./MenuListKapal.vue?vue&type=template&id=a53c0a72"
import script from "./MenuListKapal.vue?vue&type=script&lang=js"
export * from "./MenuListKapal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__